import { Row, Col, Modal, Form, Input, Image, Select, DatePicker } from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";

const AddForm = ({ show, hide, data, refresh, isUpdate }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  const onCreate = (values) => {
    const { name, pointsRequired, stock, expiryDate, description } = values;

    const payload = {
      name,
      pointsRequired,
      stock,
      expiryDate,
      description,
    };

    setLoading(true);
    if (isUpdate) {
      request({
        url: `${apiPath.updateReward}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addReward}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  //   Use Effects
  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,
      pointsRequired: data?.pointsRequired,
      description: data?.description,
      expiryDate: data.expiryDate ? moment(data.expiryDate) : undefined,
    });
  }, [data]);
  return (
    <Modal
      width={600}
      open={show}
      title={`${data ? "Update Reward" : "Add New Reward"}`}
      okText={`${data ? "Update" : "Add"}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Reward"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Reward name",
                },
              ]}
            >
              <Input placeholder="Enter Reward name " />
            </Form.Item>
          </Col>

          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Reward Points"
              name="pointsRequired"
              rules={[
                {
                  required: true,
                  message: `Please enter minumum required points`,
                },
              ]}
            >
              <Input type="number" min={1} placeholder="Enter reward points" />
            </Form.Item>
          </Col>

          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Total Stocks"
              name="stock"
              rules={[
                {
                  required: true,
                  message: `Please enter minumum stocks`,
                },
              ]}
            >
              <Input type="number" min={1} placeholder="Enter stocks" />
            </Form.Item>
          </Col>

          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Expiry Date"
              name="expiryDate"
              rules={[
                {
                  required: true,
                  message: "Please select expiry date",
                },
              ]}
              initialValues={{
                expiryDate: data?.expiryDate
                  ? moment(data.expiryDate)
                  : undefined,
              }}
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select expiry date"
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
              />
            </Form.Item>
          </Col>

          <Col span={24} lg={24}>
            <Form.Item className="mb-1" label="Description" name="description">
              <TextArea placeholder="Enter Description" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
